import React, {MouseEvent} from 'react';
import {IconName} from '../types';
import Icon from '../Icon';

interface Props {
    btn?: string;
    className?: string;
    href?: string;
    icon?: IconName;
    id?: string;
    onClick?: (e: MouseEvent) => void;
    text?: string;
    title?: string;
    type?: string;
}

const LinkButton = ({
    btn,
    className = '',
    href = 'javascript:void(0)',
    icon,
    id,
    onClick = () => {},
    text,
    title,
    type = 'button',
}: Props) => <a id={id}
        href={href}
        type={type}
        className={`${btn ? `btn btn-${btn}` : ''} ${className}`}
        title={title}
        onClick={onClick}>
    {icon && <Icon icon={icon} />}
    {icon && text && <>&nbsp;</>}
    {text && <span>{text}</span>}
</a> ;

export default LinkButton;
